import { render, staticRenderFns } from "./PosReceipts.vue?vue&type=template&id=9bf91ef2"
import script from "./PosReceipts.vue?vue&type=script&lang=js"
export * from "./PosReceipts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports